import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ShowroomBadge } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomBadge";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { PortalTooltip } from "@faire/web--source/slate/Tooltip/PortalTooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackApparelDiscoveryShowroomV2Click } from "@faire/web-api--source/events/apparelDiscovery/click/showroomV2";
import * as React from "react";
export var ShowroomTileBadge = function(param) {
    var token = param.token, customEventName = param.customEventName, tooltipZIndex = param.tooltipZIndex, className = param.className, pointerOffset = param.pointerOffset;
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var onHover = function() {
        trackApparelDiscoveryShowroomV2Click("badge-hover", token !== null && token !== void 0 ? token : "", customEventName !== null && customEventName !== void 0 ? customEventName : "");
    };
    if (isTabletAndBelow) {
        return /*#__PURE__*/ _jsx(ShowroomBadge, {
            small: true,
            className: className
        });
    }
    return /*#__PURE__*/ _jsx(PortalTooltip, {
        tooltip: /*#__PURE__*/ _jsx(Tooltip, {
            targetNode: /*#__PURE__*/ _jsx("div", {}),
            colors: {
                backgroundColor: Core.text.default
            },
            position: "bottom",
            pointerOffset: pointerOffset,
            isOpen: true,
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                color: Core.text.inverse,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "GONmmz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Showroom brands are carefully evaluated by Faire\u2019s editorial team for quality fabric, fit, and construction."
                        }
                    ]
                })
            })
        }),
        tooltipZIndex: tooltipZIndex,
        className: className,
        placement: "bottom",
        children: /*#__PURE__*/ _jsx(ShowroomBadge, {
            onMouseEnter: onHover,
            small: true
        })
    });
};
